import { PillProps } from "@geotab/react-component-library";

export const MENU_ITEM_BETA_PILL: PillProps = {
    variant: "Default",
    label: "BETA"
};